<template>
  <div class="align-center-contactus">
    <row :gutter="12">
    <column :xs="12" :sm="8" :lg="6">
       <div class="e-card full-height">
          <div class="e-card-title">Contact Us</div>
          <div class="e-card-separator"></div>
            <div class="e-card-content">
              <form ref="contactusform" @submit.prevent>
                <p class="input-container">
                  <scc-input-validator
                    :rules="[requiredRule]"
                    :value="fullName"
                    @validate="v => this.isFullNameValid=v">
                    <ejs-textbox float-label-type="Always"
                      placeholder="Your Name (required)"
                      v-model="fullName" />
                  </scc-input-validator>
                </p>
                <p class="input-container">
                  <scc-input-validator
                    :rules="[emailRule]"
                    :value="this.email"
                    @validate="v => this.isEmailValid=v">
                    <ejs-textbox float-label-type="Always"
                      ref="emailtext"
                      placeholder="Your Email (required)"
                      v-model="email" />
                  </scc-input-validator>
                </p>
                <p class="input-container">
                  <ejs-textbox float-label-type="Always"
                    placeholder="Subject"
                    v-model="subject" />
                </p>
                <p class="input-container">
                  <ejs-textbox float-label-type="Always"
                    name="message"
                    placeholder="Your Message"
                    :multiline="true"
                    v-model="message" />
                </p>
                <re-captcha>
                  <div class="e-card-actions e-card-vertical">
                    <ejs-button type="submit" @click.native="submitForm" cssClass="e-info e-card-btn">
                      Send
                    </ejs-button>
                  </div>
                </re-captcha>
              </form>
            </div>
        </div>
    </column>
    <column :xs="12" :lg="6">
      <div class="full-height">
        <contact-us-info />
      </div>
    </column>
    </row>
  </div>
</template>

<script>
import Vue from 'vue';

import { Row, Column } from 'vue-grid-responsive';

import SccInputValidator from '@/components/base/scc-input-validator.vue';
import ContactUsInfo from '@/components/contact-us-info.vue';
import { submitContactRequest } from '@/services/eserv-api';
import { emailRule, requiredRule } from '@/shared/constants';

import ReCaptcha from '@/components/re-captcha.vue';

Vue.component('row', Row);
Vue.component('column', Column);

export default {
  name: 'ContactUsPage',
  components: {
    SccInputValidator,
    ContactUsInfo,
    ReCaptcha,
  },
  data() {
    return {
      fullName: null,
      email: null,
      subject: null,
      message: null,
      createddate: new Date(),
      createduser: 'ITS',
      requiredRule,
      emailRule,
      isFullNameValid: false,
      isEmailValid: false,
    };
  },
  methods: {
    onCreate() {
      if (this.$store.getters.loggedUser != null) {
        this.$refs.emailtext.value = this.$store.getters.loggedUser.email;
      }
    },
    async submitForm() {
      // this.$parent.notificationToasts.length = 0;

      const {
        fullName, email, subject, message, createddate, createduser,
      } = this;
      if (!this.isFullNameValid || !this.isEmailValid) {
        if (this.fullName === null) this.fullName = '';
        if (this.email === null) this.email = '';
        return;
      }

      try {
        await submitContactRequest({
          fullName, email, subject, message, createddate, createduser,
        });
        this.$parent.notificationToasts.push({
          title: 'Success!',
          content: 'Request sent.',
          cssClass: 'e-toast-success',
          timeOut: 5000,
        });
      } catch (err) {
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Please fill out required fields and try again.',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }
      this.$parent.$refs.notifierRef.show();
      // location.reload();
      this.clearForm();
    },
    clearForm() {
      // console.log('clearForm');
      this.fullName = null;
      this.email = null;
      this.subject = null;
      this.message = null;
    },
  },
};
</script>

<style>
 @import '../assets/styles/eservices-base.css';
.align-center-contactus{
  margin: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%
}
.multi-textbox textarea[name=message]{
  height: 90px;
}
.input-container{
  padding-bottom:15px;
}
.full-height {
  height: 100%;
}
</style>
